import React from "react";
import "bootstrap/dist/js/bootstrap";
import "./src/styles/tailwind.css";
import "./src/styles/global.scss";
import Layout from "./src/components/layout";
import { ApolloProvider } from "@apollo/client";
import client from "./src/apollo/client";
import "@fontsource/poppins";

export const wrapPageElement = ({ element }) => {
  return (
    <ApolloProvider client={client}>
      <Layout>{element}</Layout>
    </ApolloProvider>
  );
};

export const onRouteUpdate = () => {
  if (typeof window !== `undefined`) {
    window.scrollTo(0, 0);
  }
};

// gatsby-browser.tsx

export const shouldUpdateScroll = () => {
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 0);

  return false;
};
